var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkIcon = function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8164 23.0736C26.4047 19.5637 25.7441 13.6276 21.7638 10.6924L19.3497 8.91221C15.3496 5.96251 9.78151 6.72269 6.9149 10.61C4.44505 13.9593 4.78664 18.5382 7.48751 21.628C7.93036 22.1343 8.42697 22.5909 8.96858 22.9898",
    stroke: "#6371DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1826 18.9191C15.5954 22.4276 16.256 28.3637 20.2363 31.2988L22.6504 33.079C26.6504 36.0287 32.2175 35.27 35.0841 31.3826C37.555 28.0319 37.2144 23.4516 34.5125 20.3633C34.0696 19.857 33.573 19.4004 33.0315 19.0015",
    stroke: "#6371DE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLinkIcon;